const CONSENT_KEY = "analytics-consent";

type Consent = "granted" | "denied";

export type MetrikaGoal =
  | "cv_download"
  | "radar_open"
  | "contact_click"
  | "write_form_send"
  | "skills_modal";

export function getMetrikaId(): number | null {
  const raw = process.env.REACT_APP_METRIKA_ID;
  if (!raw) return null;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function getConsent(): Consent | null {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
}

export function setConsent(value: Consent): void {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    return;
  }
}

export function isLocalhost(): boolean {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

export function isTrackingAllowed(): boolean {
  return getMetrikaId() !== null && !isLocalhost();
}

export function initMetrika(id: number): void {
  if (window.ym) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://mc.yandex.ru/metrika/tag.js";
  document.head.appendChild(script);

  const stub = ((...args: unknown[]) => {
    (stub.a = stub.a || []).push(args);
  }) as YandexMetrikaFn;
  stub.l = Date.now();
  window.ym = stub;

  window.ym(id, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });
}

export function enableMetrika(): void {
  const id = getMetrikaId();
  if (id === null || isLocalhost()) return;
  initMetrika(id);
}

export function hit(url: string): void {
  const id = getMetrikaId();
  if (id === null) return;
  window.ym?.(id, "hit", url);
}

export function reachGoal(goal: MetrikaGoal): void {
  const id = getMetrikaId();
  if (id === null) return;
  window.ym?.(id, "reachGoal", goal);
}
